<template>
  <div v-if=" activity !== null && activity !== undefined && activity.quest !== undefined" class="row activity-detail">
    <div class="col-4 info-box">
      <WhiteOutlineButton class="start-activity-button" :button-text="getStartButtonText" :stretchToFill="true"
                          v-on:clicked="startActivity"></WhiteOutlineButton>

      <WhiteOutlineButton v-if="showingRandomActivity" class="start-activity-button"
                          :button-text="'Nieuwe willekeurige activiteit kiezen'" :stretchToFill="true"
                          v-on:clicked="getNewRandomActivity"></WhiteOutlineButton>

      <div v-if="activity" class="info-window">
        <div class="header"></div>
        <div v-if="activity.quest" class="info-content">
          <div class="type">
            <ActivitySmall :activity="activity" :interactable="false"
                           :styleType="'full-color no-timestamp'"></ActivitySmall>
          </div>

          <div v-if="activity.quest.questProperties.intensity.length > 0" class="info-bar-item intensity">
            <p><span class="colorable-icon detail-icon intensity-icon"></span>
              <span class="content"><span :key="intensity"
                                          v-for="(intensity, index) in activity.quest.questProperties.intensity">
              {{
                  addCommaIfNecessary(activity.quest.questProperties.intensity, index, questIntensityToString(intensity))
                }}</span>
            </span>
            </p>
          </div>

          <div v-if="activity.quest.questProperties.duration.length > 0" class="info-bar-item time">
            <p><span class="colorable-icon detail-icon timeframe-icon"></span>
              <span class="content"><span :key="duration"
                                          v-for="(duration, index) in activity.quest.questProperties.duration">{{
                  addCommaIfNecessary(activity.quest.questProperties.duration, index, questDurationToString(duration))
                }}</span></span>
            </p>
          </div>

          <div v-if="activity.quest.questProperties.location.length > 0" class="info-bar-item time">
            <p><span class="colorable-icon detail-icon location-icon"></span>
              <span class="content"><span :key="location"
                                          v-for="(location, index) in activity.quest.questProperties.location">{{
                  addCommaIfNecessary(activity.quest.questProperties.location, index, questLocationToString(location))
                }}</span></span>
            </p>
          </div>

          <div v-if="activity.quest.questProperties.material.length > 0" class="info-bar-item tags">
            <p><span class="colorable-icon detail-icon material-icon"></span>
              <span class="content"><span :key="material"
                                          v-for="(material, index) in activity.quest.questProperties.material">{{
                  addCommaIfNecessary(activity.quest.questProperties.material, index, questMaterialToString(material))
                }}</span></span>
            </p>
          </div>

          <div v-if="activity.quest.questProperties.subject.length > 0" class="info-bar-item tags">
            <p><span class="colorable-icon detail-icon subject-icon"></span>
              <span class="content"><span :key="subject"
                                          v-for="(subject, index) in activity.quest.questProperties.subject">{{
                  addCommaIfNecessary(activity.quest.questProperties.subject, index, questSubjectToString(subject))
                }}</span></span>
            </p>
          </div>

          <p v-if="activity.quest.questDocuments?.length > 0" class="documents-title">Documenten</p>

          <div v-for:="doc in activity.quest.questDocuments" class="info-bar-item document">
            <p @click="documentClicked(doc)"><span
                class="colorable-icon document-icon"></span><span>{{ doc.originalFilename }}</span>
            </p>
          </div>

        </div>
        <div class="footer"></div>
      </div>

    </div>
    <div class="description-box-wrapper">

      <div class="info-window">
        <div class="header"></div>
        <div class="info-content">

          <!--Quest media item-->
          <div class="row image mt-3"
               v-if="activity?.quest.mediaItem && activity.quest.mediaItem.type !== mediaItemTypeEnum.none">
            <div class="col">
              <div class="activity-image"
                   v-if="activity.quest.mediaItem.type === mediaItemTypeEnum.image && activity.quest.mediaItem.imageAsset">
                <img class="img-fluid" :src="activity.quest.mediaItem.imageAsset.url" alt="Activiteit afbeelding"/>
              </div>
              <div class="embed-responsive embed-responsive-16by9 activity-video"
                   v-if="activity.quest.mediaItem.type === mediaItemTypeEnum.video && activity.quest.mediaItem.videoUrl">
                <iframe class="embed-responsive-item"
                        :src="convertYoutubeUrlToEmbedUrl(activity.quest.mediaItem.videoUrl)"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>
          <div class="description">
            <p>{{ activity.quest.descriptionTeacher }}</p>

            <div v-if="activity.quest.format === 'quiz'">
              <div :key="question" v-for="question in activity.quest.quizQuestions">
                <p>{{ question.phrase }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="footer"></div>
      </div>
    </div>

  </div>
</template>

<script>

import { QuestMediaTypeEnum, QuestFormatEnum, QuestTypeEnum, ActivityApi, BuddyApi } from "sandpiper_api";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";

import QuestPropertiesHelper from "@/mixins/QuestPropertiesHelper";
import ActivitySmall from "@/components/Activities/ActivitySmall";
import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
import log from "@/utils/logger";
import {ActivityType} from "@/enums/ActivityType";


export default {
  name: "ActivityDetail",
  components: { WhiteOutlineButton, ActivitySmall },
  emits: [ "startPhoneView", "randomActivityClicked" ],
  props: {
    name: String,
    open: Boolean,
    activity: Object,
    buddy: Object,
    showingRandomActivity: Boolean,
  },
  mixins: [ QuestPropertiesHelper, YoutubeVideoEmbedder ],
  inject: [ "doApiRequest" ],
  watch: {
    open: {
      handler()
      {
        if (this.open)
        {
          console.log("opening");
        }
        else
        {
          console.log("closing");
        }
      },
      deep: true,
    },

  },
  data()
  {
    return {
      mediaItemTypeEnum: new QuestMediaTypeEnum(),
      questFormatEnum: new QuestFormatEnum(),
      questTypeEnum: new QuestTypeEnum(),

      show: this.open,
      //Todo: (lm) Defining every object property to ensure reactivity like this seems (has to be) wrong?
    }
  },
  computed: {
    getStartButtonText()
    {
      let text = "";
      if (this.activity.quest.format === "puzzle")
      {
        text = "PUZZEL STARTEN";
      }
      else if (this.activity.quest.format === "quiz")
      {
        text = "QUIZ STARTEN";
      }
      else
      {
        text = "ACTIVITEIT STARTEN";
      }
      return text;
    }
  },
  methods: {

    async startActivity()
    {
      console.log("[AD] starting activity")
      let activity = {
        buddy: this.buddy,
        plannedDate: new Date(),
        quest: this.activity.quest,
      }

      log.info("sending activity create request")
      log.info(activity);
      let result = await this.doApiRequest(() => new ActivityApi().createActivity(activity));
      log.info(result);
      this.$emit("startPhoneView", result.id, "activityDetail");
    },

    addCommaIfNecessary(array, index, value)
    {
      if (index !== array.length - 1)
      {
        return value + `, `;
      }
      else
      {
        return value;
      }
    },

    documentClicked(doc)
    {
      window.open(doc.url, "_blank");
    },

    async getNewRandomActivity()
    {
      let quest = await this.fetchRandomQuest();
      if (quest !== null)
      {
        this.$emit("randomActivityClicked", quest.id, true);
      }
    },

    async fetchRandomQuest()
    {
      try
      {
        this.fetchingActivity = true;
        const response = await this.doApiRequest(() => new BuddyApi().getRandomQuestForBuddy(this.buddy.id, {questType: ActivityType.IMPULSE}));

        log.info("Fetch activity response: %o", response);
        return response;
      }
      catch (e)
      {
        console.log(e);
        return null;
        // TODO - handle exception
      }
      finally
      {
        this.fetchingActivity = false;
      }
    },

  },
  mounted() {
    /*
    if(this.skipDetailPage)
    {
      console.log("skipping detail page")
      this.startActivity();
    }
    */
  }
}
</script>

<style lang="scss" scoped>

::-webkit-scrollbar {
  display: none;
}

.top-bar {
  margin: 0 2rem;
  margin-top: 7rem;
  height: 50px;
  display: flex;
  justify-content: space-between;

  p {
    font-weight: bold;
    font-size: 2rem;
    color: white;
  }
}

.info-window {

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

  .pips {
    display: flex;
    justify-content: center;
    align-items: center;

    .pip {
      width: 10px;
      height: 10px;
      padding: 0px;
      border-radius: 10px;
      background-color: white;
      margin: 5px;

      &.large {
        width: 15px;
        height: 15px;
      }
    }
  }
}


.activity-detail {
  padding-top: 6%;
  margin: 0 2rem;
  margin-bottom: 2rem;
  height: 100%;
  overflow-y: scroll;
  justify-content: center;
}

.activity-list {
  margin: 0 2rem;
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
  overflow: overlay;

}

.info-box, .description-box {
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}

.info-box {
  flex: 0 0 35%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 35%;
  margin-right: 2.5%;


  .info-bar-content {
    overflow: scroll;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }


  .info-bar-item {
    width: 100%;
    background-color: rgba(33, 34, 58, 0.6);
    //background-image: url("~@/assets/image/button/bb_button.svg");
    display: flex;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;

    p {
      margin: 0;
      color: white;
      display: flex;
      align-items: center;
    }

    &.document {
      cursor: pointer;

      .document-icon {
        margin-right: 5px;
      }

    }
  }

  .documents-title {
    font-weight: bold;
    font-size: 1.3rem;
    color: white;
  }


  .type-icon {
    display: block;
    width: 36px;
    height: 36px;
    background-image: url("~@/assets/image/bb_icon-customize.svg");
    margin-right: 10px;
  }

  .battery-icon {
    display: block;
    width: 36px;
    height: 36px;
    background-image: url("~@/assets/image/bb_icon-customize.svg");
    margin-right: 10px;
  }
}

.start-activity-button {
  margin-bottom: 30px;
  height: min(5vw, 11vh);
}

.description-box-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex: 0 0 60%;
  max-width: 900px;
}


.description {
  width: 100%;
  height: 50%;
  overflow-y: scroll;
  padding: 0 25px;
  font-size: 1.3rem;

  p {
    margin-top: 15px;
    color: white;
    white-space: pre-line;

  }
}


.start-planned-activity-button {
  //min-width: 350px;
  //width: 50%;
  height: 100%;
  margin-top: 2rem;
}

.to-earn-batteries {
  width: 80%;
  height: 100px;
  position: absolute;
  bottom: -38px;
  background-image: url("~@/assets/image/bb_frame-title.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2%;

  p {
    color: white;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 0;

    span {
      width: 35px;
      height: 60px;
    }
  }
}

.activity-tag {
  display: block;
  width: 100%;
}

.detail-icon {
  width: 25px;
  height: 25px;
  mask-size: contain;
  margin-right: 10px;
}

.image {
  justify-content: center;
}

.activity-image {
  display: flex;
  justify-content: center;
}
</style>